import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetOrders = (params = {}, queryOptions = {}) => {
  const {
    filters: { recognitionId = '', searchTerm = '', giftStatus = [], type = '', email = '' } = {},
    options: { populate = false } = {},
    pagination: { page = 1, limit = 10 } = {}
  } = params;

  return useQuery(
    ['orders', searchTerm + page + limit + giftStatus + recognitionId + type + email],
    () => {
      return services.orders(
        cleanObjectEmptyFields({
          filters: {
            type,
            email,
            recognitionId,
            searchTerm,
            giftStatus
          },
          options: {
            populate
          },
          pagination: {
            limit,
            page
          }
        })
      );
    },
    queryOptions
  );
};
